import { Layers } from "appworks/graphics/layers/layers";
import { LoaderService } from "appworks/loader/loader-service";
import { Services } from "appworks/services/services";
import { SoundEvent } from "appworks/services/sound/sound-events";
import { SoundService } from "appworks/services/sound/sound-service";
import { Contract } from "appworks/utils/contracts/contract";

export class AgsSoundService extends SoundService {

    protected volume: number = 0.8;

    public unmuteLoadScreen(): Contract<void> {
        return new Contract<void>((resolve) => {
            if (!this.loaded && !this.isLoading) {
                Layers.get("Alerts").setScene("load_sounds").execute();
                Services.get(LoaderService).loadSounds().then(() => {
                    if (Layers.get("Alerts").currentSceneIs("load_sounds")) {
                        Layers.get("Alerts").defaultScene().execute();
                    }

                    resolve(null);
                    this.event(SoundEvent.sounds_ready);
                });
            } else {
                resolve(null);
            }

            this.setMute(false);
        });
    }
}